import { SVGProps } from 'react';

/**
 * Inline SVG icons for the location autocomplete. Kept local and Tailwind-friendly
 * (colour via currentColor) so the autocomplete does not depend on the Fela icon set.
 */

export const LocationPinIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 20" fill="currentColor" aria-hidden {...props}>
    <path d="M8 3.7c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm0 6.4c-1.4 0-2.5-1.1-2.5-2.4S6.6 5.2 8 5.2s2.5 1.1 2.5 2.4-1.1 2.5-2.5 2.5z" />
    <path d="M13.8 2.4C12.3.9 10.2 0 8 0 3.6 0 0 3.4 0 7.6c0 1.4.4 2.8 1.2 4l6.2 8.1c.1.2.4.3.6.3.2 0 .5-.1.6-.3l6.2-8.2v-.1c.8-1.2 1.2-2.6 1.2-3.9 0-1.9-.7-3.7-2.2-5.1zm-.3 8.2L8 17.9l-5.5-7.3c-.6-.9-.9-2-.9-3.1 0-3.3 2.9-6 6.5-6 1.8 0 3.4.7 4.7 1.9 1.1 1.1 1.7 2.6 1.7 4.1-.1 1.1-.4 2.1-1 3.1z" />
  </svg>
);

export const CrossBoldIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden {...props}>
    <path d="M15.6 13.5L10 8l5.5-5.5c.6-.6.6-1.5 0-2-.6-.6-1.5-.6-2 0L8 6 2.5.4C1.9-.2 1-.2.5.4c-.6.6-.6 1.5 0 2L6 8 .5 13.5c-.6.6-.6 1.5 0 2 .2.3.5.5.9.5s.7-.1 1-.4L8 10l5.5 5.5c.6.6 1.5.6 2 0 .6-.5.6-1.4.1-2z" />
  </svg>
);

export const SearchIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" fill="none" aria-hidden {...props}>
    <circle cx="5.99992" cy="5.99992" r="4.66667" stroke="currentColor" strokeLinejoin="round" />
    <path
      d="M14.2699 14.2697L11 11"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
